import { Observable } from 'rxjs';
import AxiosSubscriber from '../../factory/AxiosSubscriber';

export class DeleteSingleNotificationAPI {
  constructor() {
    this.subscription = null;
  }

  subscribe(messageId, next, complete, error) {
    const token = localStorage.getItem("token");

    const httpConfig = {
      url: `/message/${messageId}`,
      method: 'delete',
      headers: {
        'accept': 'application/json',
        'Content-Type': `multipart/form-data;`,
        'Authorization': `Bearer ${token}`
      }
    };

    let observable$ = new Observable((observer) => {
      return new AxiosSubscriber(observer, httpConfig);
    });

    this.subscription = observable$.subscribe({
      next: next,
      complete: complete,
      error: error
    });
  }

  unsubscribe() {
    if (this.subscription !== undefined && this.subscription !== null) {
      this.subscription.unsubscribe();
    }
  }
}